const breakpoints = {
    sm: 0,
    mobileMax: 26.63, // 426px
    beforeTablet: 47.94, // 767px
    md: 48, // 768px
    beforeTabletPx: 767,
    tabletPx: 768,
    laptop: 64, // 1024px
    beforeDesktop: 74.94, // 1199px
    lg: 75, // 1200px
    beforeDesktopPx: 1199,
    desktopPx: 1200,
    screenHeightChange: 62.5625,
    laptopHeightsRange: "(min-height: 43.75rem) and (max-height: 62.5rem)" // Screens with 700px - 1000px height range
};

export default breakpoints;
